import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLazyLoadImage } from 'tmt-ui-kit';

import { path } from '~/utils/media';

const Container = styled.div`
  position: relative;
  padding-bottom: 64%;
  border: 1px solid ${props => props.theme.articleBorderGray};
  @media(max-width: 600px) {
    padding-bottom: 60%;
  }
`;

const ArticleBoxContainer = styled.div`
  color: ${props => props.theme.black};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  &:hover {
    color: ${props => props.theme.darkOrange};
  }
`;

const ArticleImageContainer = styled.div`
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

const ArticleImage = styled.img`
  width: 100%;
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: ${props => props.theme.imageTransition};
`;

const TitleContainer = styled.div`
  padding: 15px;
`;

const ArticleTitle = styled.p`
  font-weight: 500;
  font-size: 15px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  max-height: 40px;
  -webkit-line-clamp: 2;
  margin: 0;
`;

const ArticleNormalStyleCard = props => {
  const { data } = props;
  const imgRef = useRef();
  useLazyLoadImage(imgRef);
  return (
    <Container>
      <ArticleBoxContainer>
        <ArticleImageContainer>
          <ArticleImage
            ref={imgRef}
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            data-src={data.thumbnail_image ? path(data.thumbnail_image, 'articleThumbnailCover') : ''}
            data-srcSet={data.thumbnail_image ? path(data.thumbnail_image, 'articleThumbnailCover') : ''}
            alt={data.title}
          />
        </ArticleImageContainer>
        <TitleContainer>
          <ArticleTitle>{data.title}</ArticleTitle>
        </TitleContainer>
      </ArticleBoxContainer>
    </Container>
  );
};

ArticleNormalStyleCard.propTypes = {
  data: PropTypes.object,
};

export default ArticleNormalStyleCard;
